module Bookhus.SearchWidget {
    export interface IControlSettings {
        showPeriod: boolean;
        maxPeriodDays: number;

        showRooms: boolean;
        maxRooms: number;

        showPersons: boolean;
        maxPersons: number;

        showDistanceToSea: boolean;
        showDistanceToGrocer: boolean;
        showArea: boolean;

        facilities: SearchFilterType[];
    }

    export enum SearchFilterType {
        Opvaskemaskine,
        Vaskemaskine,
        Tørretumbler,
        Husdyr,
        Rygning,
        Brændeovn,
        Internet,
        Parabol,
        Handicapvenligt,
        Havudsigt,
        MaxPrice,
        Spa,
        Sauna,
        PoolOut,
        PoolIn,
        Garage,
        Boat,
        Ekkolod,
        VhsRadio,
        Radar,
        MinTwoToilets,
        Fiskerenseplads,
        Mikroovn,
        Cykler,
        Feriecenter,
        Swimmingpool,
        Hus,
        Lejlighed,
        Skiområde,
        Storby,
        Bjergby,
        UdsigtVand,
        UdsigtNatur,
        LadeStander,
        Varmepumpe,
        HusdyrIkkeTilladt
    }

    enum PromiseType {
        loadLocations,
        loadRelationships,
        searchData,
        loadControlSettings
    }


    export class HouseLocation {
        id: number;
        name: string;
        order: number;
        active: boolean;
    }

    export class SearchwidgetDataservice {
        private static BOOKHUS_GREY_PIN: string = '/content/siteimages/googleMarkers/bookhus_grey_pin.svg';
        private static BOOKHUS_RED_PIN: string = '/content/siteimages/googleMarkers/bookuhs_red_pin.svg';
        private static BOOKHUS_RED_OUTLINE_PIN: string = '/content/siteimages/googleMarkers/bookhus_red_outline_pin.svg';

        markers: IMarker[];
        controlSettings: IControlSettings;
        locations: HouseLocation[];
        relationships: { id: number, name: string }[];

        searchCridentials: ISearchCridentials = null;

        promises: JQueryXHR[] = [];

        loadDataAjax(): JQueryXHR {
            var xhr = $.getJSON('/api/housesearch?getAll=true', (markers: IMarker[]) => {
                this.markers = markers;
            });

            return xhr;
        }
        searchData(filters?: ISearchCridentials): JQueryXHR {
            var self = this;

            if (filters) {
                self.searchCridentials = filters;
            }

            if (self.promises[PromiseType.searchData]) {
                return self.promises[PromiseType.searchData];
            }

            self.promises[PromiseType.searchData] = $.getJSON("/api/housesearch", self.searchCridentials,
                (markers: IMarker[]) => {
                    self.markers = markers;
                });

            self.promises[PromiseType.searchData].done(() => {
                self.promises[PromiseType.searchData] = null;
            });

            return self.promises[PromiseType.searchData];
        }

        loadControlSettings(): JQueryXHR {
            var self = this;
            if (self.promises[PromiseType.loadControlSettings]) {
                return self.promises[PromiseType.loadControlSettings];
            }

            self.promises[PromiseType.loadControlSettings] = $.getJSON("/api/housesearch/getcontrols", { _: new Date().getTime() }, (controlSettings: IControlSettings) => {
                self.controlSettings = controlSettings;
            });

            self.promises[PromiseType.loadControlSettings].done(() => {
                self.promises[PromiseType.loadControlSettings] = null;
            });

            return self.promises[PromiseType.loadControlSettings];
        }

        loadLocations(): JQueryXHR {
            var self = this;
            if (self.promises[PromiseType.loadLocations]) {
                return self.promises[PromiseType.loadLocations];
            }

            self.promises[PromiseType.loadLocations] = $.getJSON("/api/housesearch/getlocations", { _: new Date().getTime() }, (locations: HouseLocation[]) => {
                self.locations = locations;
            });

            self.promises[PromiseType.loadLocations].done(() => {
                self.promises[PromiseType.loadLocations] = null;
            });

            return self.promises[PromiseType.loadLocations];
        }

        loadRelationship(): JQueryXHR {
            var self = this;
            if (self.promises[PromiseType.loadRelationships]) {
                return self.promises[PromiseType.loadRelationships];
            }

            self.promises[PromiseType.loadRelationships] = $.getJSON("/api/housesearch/getRelationships", { _: new Date().getTime() }, (relationships: {id: number, name: string}[]) => {
                self.relationships = relationships;
            });

            self.promises[PromiseType.loadRelationships].done(() => {
                self.promises[PromiseType.loadRelationships] = null;
            });

            return self.promises[PromiseType.loadRelationships];
        }

        getGoogleMarkers(googleMap: google.maps.Map, overlay: google.maps.OverlayView): google.maps.Marker[] {
            var self = this;

            var result: google.maps.Marker[] = [];

            if (googleMap == null || overlay == null || googleMap == undefined) {
                return result;
            }

            self.markers.forEach((marker) => {

                var googleMarker = new google.maps.Marker({
                    position: marker.position as any,
                    icon: {
                        url: SearchwidgetDataservice.BOOKHUS_GREY_PIN,
                        scaledSize: new google.maps.Size(32, 32)
                    },
                    title: marker.title,
                    map: googleMap,
                    markerId: 0,
                    markerType: null
                });

                var content = `<span id="infowindow_${marker.type}_${marker.id}"></span>${marker.description}`;
                var infowindow = new google.maps.InfoWindow({
                    content: content,
                    disableAutoPan: true
                });


                googleMarker.addListener("click", () => {
                    var self = this;
                    infowindow.open(googleMap, googleMarker);
                });

                google.maps.event.addListener(infowindow, 'domready', function () {
                    var img = $("#iw-container-" + marker.id + " img");
                    var url = img.data("src") as any;
                    img.attr("src", url);

                    var projection = overlay.getProjection();

                    //Convert position to pixel
                    var point = projection.fromLatLngToContainerPixel(googleMarker.getPosition());
                    var container = $(`#infowindow_${marker.type}_${marker.id}`).parents('.gm-style-iw.gm-style-iw-c:first');

                    //Calculate new latlng based on pixel
                    point.y = point.y - (container.height() / 2) - 20;

                    //Convert pixel back to position
                    var position = projection.fromContainerPixelToLatLng(point);

                    googleMap.panTo(position);
                });
                result.push(googleMarker);
            });
            return result;
        }

        GetCssIcon(type: SearchFilterType): string {
            switch (type) {
                case SearchFilterType.Opvaskemaskine:
                    return "fas fa-washer";
                case SearchFilterType.Vaskemaskine:
                    return "fas fa-washer";
                case SearchFilterType.Tørretumbler:
                    return "fas fa-dryer";
                case SearchFilterType.Husdyr:
                    return "fas fa-dog";
                case SearchFilterType.HusdyrIkkeTilladt:
                    return "fak fa-pet-ban";
                case SearchFilterType.Rygning:
                    return "fas fa-smoking";
                case SearchFilterType.Brændeovn:
                    return "fas fa-fireplace";
                case SearchFilterType.Internet:
                    return "fas fa-wifi";
                case SearchFilterType.Parabol:
                    return "fas fa-satellite";
                case SearchFilterType.Handicapvenligt:
                    return "fab fa-accessible-icon";
                case SearchFilterType.Havudsigt:
                    return "fas fa-eye";
                case SearchFilterType.MaxPrice:
                    return "fas fa-tags";
                case SearchFilterType.Spa:
                    return "fas fa-hot-tub";
                case SearchFilterType.Sauna:
                    return "fas fa-hot-tub";
                case SearchFilterType.PoolOut:
                    return "fas fa-swimming-pool";
                case SearchFilterType.PoolIn:
                    return "fas fa-swimming-pool";
                case SearchFilterType.Garage:
                    return "fas fa-garage";
                case SearchFilterType.Boat:
                    return "fas fa-ship";
                case SearchFilterType.Ekkolod:
                    return "fas fa-39";
                case SearchFilterType.VhsRadio:
                    return "fas fa-radio";
                case SearchFilterType.Radar:
                    return "fas fa-radar";
                case SearchFilterType.MinTwoToilets:
                    return "fas fa-toilet";
                case SearchFilterType.Fiskerenseplads:
                    return "fas fa-fish";
                case SearchFilterType.Mikroovn:
                    return "fas fa-microwave";
                case SearchFilterType.Cykler:
                    return "fas fa-bicycle";
                case SearchFilterType.Feriecenter:
                    return "fas fa-bags-shopping";
                case SearchFilterType.Swimmingpool:
                    return "fas fa-swimming-pool";
                case SearchFilterType.Hus:
                    return "fas fa-house";
                case SearchFilterType.Lejlighed:
                    return "fas fa-building";
                case SearchFilterType.Skiområde:
                    return "fas fa-skiing";
                case SearchFilterType.Storby:
                    return "fas fa-city";
                case SearchFilterType.Bjergby:
                    return "fas fa-mountains";
                case SearchFilterType.UdsigtVand:
                    return "fas fa-eye";
                case SearchFilterType.UdsigtNatur:
                    return "fas fa-eye";
                case SearchFilterType.LadeStander:
                    return "fas fa-charging-station";
                case SearchFilterType.Varmepumpe:
                    return "fa-kit fa-underfloor-heating";
                default:
                    return "";
            }
        }

        setPartialSearchCridentials(filters: ISearchCridentials): void {
            var self = this;
            self.extend(self.searchCridentials, filters);
        }

        private extend(oldObject, newObject): void {
            var self = this;
            if (oldObject == null) {
                oldObject = {} as ISearchCridentials;
            }
            for (var key in newObject) {
                oldObject[key] = newObject[key];
            }
            self.searchCridentials = oldObject;
        }

    }
}
